<template>
    <header id="header" v-bind:class="{scrolled: showHeader}">
        <a href="/#" v-scroll-to="'#hero'"><img v-bind:class="{show: !showHeader}" src="img/cafecanna-logo.svg" alt="Café Canna logo" class="logo"><img v-bind:class="{show: showHeader}" class="logo" src="img/cafecanna-logo-blue.svg" alt="Café Canna logo"></a>
        <div class="overlay" v-bind:class="{active: showMobileNav}">
            <div class="burger" v-on:click="mobileNav" v-bind:class="{open: showMobileNav}">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <nav>
                <ul class="menu">
                    <li><a v-on:click="navclick" href="/#menu" v-scroll-to="'#menu'">Menus</a></li>
                    <li><a v-on:click="navclick" href="/#booking" v-scroll-to="'#booking'">Booking</a></li>
<!--                    <li><a v-on:click="navclick" href="./foraged-seaweed-salad-recipe-kit.html">Shop</a></li>-->
                    <li><a v-on:click="navclick" href="/#getting-here" v-scroll-to="'#getting-here'">Getting here</a></li>
                    <li><a v-on:click="navclick" href="/#contact" v-scroll-to="'#contact'">Contact us</a></li>
                </ul>
            </nav>
        </div>
    </header>

</template>

<script>

    export default {
        name: 'Header',
        data() {
            return {
                showHeader: false,
                showMobileNav: false,
            }
        },
        methods: {
            handleScroll: function() {
                if (window.scrollY > 500) {
                    this.showHeader = true;
                } else {
                    this.showHeader = false;
                }
            },
            mobileNav: function() {
                this.showMobileNav = !this.showMobileNav;
            },
            navclick: function() {
                this.showMobileNav = false;
            }
        },
        created: function() {
            window.addEventListener("scroll", this.handleScroll);
        }
    }
</script>